import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Grid } from "@material-ui/core";
import RegularButton from "components/CustomButtons/Button";
import Snackbars from "components/Snackbar/Snackbar.js";
import { useTableSgcConfigurationsConfig } from "./hooks";
import { SgcConfigurationsSelectStation } from "./SgcConfigurationsSelectStation";
import { getSgcConfigurations } from "redux/actions/sgcConfigurations/sgcConfigurationsAction";

const style = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
};

export const SgcConfigurationsInputs = () => {
  const dispatch = useDispatch();
  const { clearSnackBar } = useTableSgcConfigurationsConfig();
  const { station, snackBar } = useSelector(({ sgcConfigurations }) => sgcConfigurations);

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(getSgcConfigurations(station));
  };

  return (
    <>
      <form
        onSubmit={handleSubmit}
        style={{
          width: "100%",
          padding: 4,
        }}
      >
        <Grid container spacing={1}>
          <Grid item xs={12} sm={10} style={style}>
            <SgcConfigurationsSelectStation />
          </Grid>

          <Grid
            item
            xs={12}
            sm={2}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <RegularButton color="info" onClick={handleSubmit} fullWidth>
              buscar
            </RegularButton>
          </Grid>
        </Grid>
      </form>
      <Snackbars
        place="tr"
        color="danger"
        message={snackBar.msg}
        open={snackBar.isOpen}
        closeNotification={clearSnackBar}
        close
      />
    </>
  );
};
